// Company bank account (same details as the debt letter). Company customers must pay
// here while payment links are off, so the transfer lands in company accounting.
export const COMPANY_BANK = {
  bankName: 'ธนาคารไทยพาณิชย์ (SCB)',
  accountNumber: '429-190745-9',
  accountNameTh: 'บริษัท สไมล์ เอ็นเอสจี จำกัด',
};

export const COMPANY_BANK_NOTICE = '⚠️ ลูกค้าบริษัท — ช่วงปิดลิ้งค์ ต้องให้โอนเข้าบัญชีบริษัทเท่านั้น (SCB 429-190745-9)';

export const companyBankText = (gender = 'ครับ') =>
  `ชำระผ่านโอนบัญชีธนาคาร${gender}\n${COMPANY_BANK.bankName}\nเลขบัญชี ${COMPANY_BANK.accountNumber}\nชื่อบัญชี ${COMPANY_BANK.accountNameTh}\n\nหลังชำระแล้วรบกวนส่งสลิปยืนยันด้วยนะ${gender}`;
